const ConsignmentType = `
  id
  description
  updatedAt
`;

export default ConsignmentType;
